module.exports = __webpack_public_path__ + "static/adaptable-dab5f6e271959036328ed15bed076183.png";